// Chakra imports
import {
    Flex,
    Grid,
    SimpleGrid,
    Switch,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";
  // assets
  // Custom icons
  import { CartIcon, DocumentIcon, GlobeIcon, WalletIcon, } from "../components/Icons/Icons.js";
  import React, {useState} from "react";
  import MiniStatistics from "../components/MiniStatistics";
  import SalesOverview from "../components/SalesOverview";
  import PaymentChart from "../components/Dashboard/PaymentChart";
  import PaymentYear from "../components/Dashboard/PaymentYear";
  import axios from "axios";
import DashboardWalletsTable from "../components/Tables/components/DashboardWallets";


export default function Dashboard() {
    const iconBoxInside = useColorModeValue("white", "white");
    const [selected, setSelected] = useState(true)

    const columns = React.useMemo(
        () => [
            {
                header: 'name',
                accessorKey: 'name',
            },
            {
                header: 'balance',
                accessorKey: 'balance',
            },
            {
                header: 'credit',
                accessorKey: 'credit',
            }
        ],
        [])

    const toggle = () => {
        setSelected(!selected)
    }

    return (
        <Flex flexDirection='column' pt={{ base: "120px", md: "75px" }}>
            <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing='24px'>
                <MiniStatistics
                    title={"Today's Moneys"}
                    amount={"$53,000"}
                    percentage={55}
                    icon={<WalletIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
                /><MiniStatistics
                title={"Total Sales"}
                amount={"$173,000"}
                percentage={8}
                icon={<CartIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
            />
                <MiniStatistics
                    title={"Today's Users"}
                    amount={"2,300"}
                    percentage={5}
                    icon={<GlobeIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
                />
                <MiniStatistics
                    title={"New Clients"}
                    amount={"+3,020"}
                    percentage={-14}
                    icon={<DocumentIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
                />

            </SimpleGrid>

            <Grid>
                <Flex>
                    <Text
                        color="gray.400"
                        htmlFor="normal-switch"
                    >
                        <label htmlFor="normal-switch">
                            <Switch
                                id="normal-switch"
                                colorScheme='teal'
                                onChange={toggle}
                                checked={selected}
                                className="react-switch"
                            />
                            <span> {selected ? ' amount' : ' count'}</span>
                        </label>

                    </Text>
                </Flex>
            </Grid>

            <Grid
                templateColumns={{ sm: "1fr", lg: "1fr" }}
                templateRows={{ sm: "repeat(1, 1fr)", lg: "1fr" }}
                mb={{ lg: "26px" }}
                maxW={'100%'}
                maxH={'100%'}
            >
                <Text
                    color="gray.400"
                    htmlFor="normal-switch"
                >
                </Text>
                <SalesOverview
                    title={"За полгода"}
                    chart={selected ? <PaymentYear getAction={true} txParam={'tx_sum'}/> : <PaymentYear getAction={true} txParam={'tx_count'}/>}
                />

            </Grid>

            <Grid
                templateColumns={{ sm: "1fr", lg: "1fr" }}
                templateRows={{ sm: "repeat(1, 1fr)", lg: "1fr" }}
                maxW={'100%'}
                maxH={'100%'}
            >
                <SalesOverview
                    title={"График платежей"}
                    chart={selected ? <PaymentChart getAction={true} txParam={'tx_sum'}/> : <PaymentChart getAction={true} txParam={'tx_count'}/>}
                />

            </Grid>
            <DashboardWalletsTable
                title={"Кошельки партнеров"}
                columns={columns}
            />
        </Flex>
    );
}

async function fetchPercentDay(token) {
    const started_to = new Date();
    const started_from = new Date();
    started_from.setHours(0,0,0,0);
    const started_to2 = new Date(started_to);
    const started_from2 = new Date(started_from);
    started_from.setDate(started_from.getDate())
    started_to2.setDate(started_to2.getDate() - 1)
    started_from2.setDate(started_from2.getDate() - 1)

    let A1 = 0, B1 = 0, A2 = 0, B2 = 0

    const response = await axios.get(`/api/v1/transactions/aggregate?started_from=${getFormatDate(started_from)}&started_to=${getFormatDate(started_to)}&aggregate_by=tx_count&group_by=type&status=Charged`,
        {headers: {Authorization: token}})
    const res = await response.data;
    let data = res.aggr
    if (data.length !== 0) {
        data.forEach(id => { if (id.type === 'payment') {B1 = id.count} if (id.type === 'payout') {B2 = id.count}})
    }
    const response2 = await axios.get(`/api/v1/transactions/aggregate?started_from=${getFormatDate(started_from2)}&started_to=${getFormatDate(started_to2)}&aggregate_by=tx_count&group_by=type&status=Charged`,
        {headers: {Authorization: token}})
    const res2 = await response2.data;
    let oldData = res2.aggr
    if (oldData.length !== 0) {
        oldData.forEach(id => { if (id.type === 'payment') {A1 = id.count} if (id.type === 'payout') {A2 = id.count}})
    }

    let arr = [0,0]
    if (A1 !== 0 && B1 !== 0) {
        arr[0] = Number((100 - (100/(B1/A1))).toFixed(1))
    }
    if (A2 !== 0 && B2 !== 0) {
        arr[1] = Number((100 - (100/(B2/A2))).toFixed(1))
    }

    return arr;
}

async function fetchPercentWeek(token) {
    const started_to = new Date();
    const started_from = new Date();

    started_from.setHours(0,0,0,0);
    const i = started_from.getDay()
    started_from.setDate(started_from.getDate() - (i - 1))

    const started_to2 = new Date(started_to);
    const started_from2 = new Date(started_from);

    started_to2.setDate(started_from2.getDate() - (i - 2))
    started_from2.setDate(started_to2.getDate() - (i - 1))

    let A1 = 0, B1 = 0, A2 = 0, B2 = 0

    const response = await axios.get(`/api/v1/transactions/aggregate?started_from=${getFormatDate(started_from)}&started_to=${getFormatDate(started_to)}&aggregate_by=tx_count&group_by=type&status=Charged`,
        {headers: {Authorization: token}})
    const res = await response.data;
    const data = res.aggr
    if (data.length !== 0) {
        data.forEach(id => { if (id.type === 'payment') {B1 = id.count} if (id.type === 'payout') {B2 = id.count}})
    }
    const response2 = await axios.get(`/api/v1/transactions/aggregate?started_from=${getFormatDate(started_from2)}&started_to=${getFormatDate(started_to2)}&aggregate_by=tx_count&group_by=type&status=Charged`,
        {headers: {Authorization: token}})
    const res2 = await response2.data;
    const oldData = res2.aggr
    if (oldData.length !== 0) {
        oldData.forEach(id => { if (id.type === 'payment') {A1 = id.count} if (id.type === 'payout') {A2 = id.count}})
    }

    let arr = [0,0]
    if (A1 !== 0 && B1 !== 0) {
        arr[0] = Number((100 - (100/(B1/A1))).toFixed(1))
    }
    if (A2 !== 0 && B2 !== 0) {
        arr[1] = Number((100 - (100/(B2/A2))).toFixed(1))
    }

    return arr;
}

function getFormatDate(date) {
    const yyyy = date.getFullYear();
    let mm = date.getMonth() + 1;
    let dd = date.getDate();
    let h = date.getHours();
    let m = date.getMinutes();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    if (h < 10) h = '0' + h;
    if (m < 10) m = '0' + m;

    return yyyy + '-' + mm +  '-' + dd + 'T' + h +':' + m + ':00';
}
